export default {
  features: {
    createRejectCase: {
      button: "So'rovni o'chirish",
    },
  },
};
